module.exports = __webpack_public_path__ + "img/zd-top-3.16794a2c.svg";